var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "export-templates-modal",
          attrs: {
            id: "export-templates-modal",
            title: "Export",
            "title-class": "text-lg font-semibold leading-none tracking-tight",
            centered: "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _vm.showBar && _vm.isSaving
                    ? _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("ProgressBarComponent", {
                            attrs: { current: _vm.current, total: _vm.total },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex w-100 justify-content-end" },
                    [
                      !["idml"].includes(_vm.selectedFormat)
                        ? _c(
                            "a",
                            {
                              staticClass: "export-save-settings-link m-1",
                              attrs: { href: "" },
                              on: { click: _vm.showSaveSettingsModal },
                            },
                            [_vm._v("\n          Save settings\n        ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !["idml"].includes(_vm.selectedFormat) &&
                      _vm.activeDownloadSetting !== null
                        ? _c(
                            "a",
                            {
                              staticClass: "export-save-settings-link m-1",
                              attrs: { href: "" },
                              on: { click: _vm.showUpdateSettingsModal },
                            },
                            [_vm._v("\n          Update settings\n        ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.lastResults.saveToFolder.length > 0 &&
                      (_vm.selectedFormat === "pptx" ||
                        _vm.selectedFormat === "pdf")
                        ? _c(
                            "b-button",
                            {
                              staticClass: "m-1 ml-3",
                              attrs: {
                                disabled: _vm.isDownloadingFileList,
                                variant: "primary",
                              },
                              on: { click: _vm.downloadFileList },
                            },
                            [
                              _vm.isDownloadingFileList
                                ? _c("div", [
                                    _c("span", {
                                      staticClass:
                                        "spinner-border spinner-border-sm",
                                      attrs: {
                                        role: "status",
                                        "aria-hidden": "true",
                                      },
                                    }),
                                    _vm._v(
                                      "\n            Downloading File List...\n          "
                                    ),
                                  ])
                                : _c("span", [_vm._v("Download File List")]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "m-1 ml-auto",
                          attrs: { variant: "primary", disabled: _vm.isSaving },
                          on: { click: _vm.onSave },
                        },
                        [
                          _vm.isSaving
                            ? _c("div", [
                                _c("span", {
                                  staticClass:
                                    "spinner-border spinner-border-sm",
                                  attrs: {
                                    role: "status",
                                    "aria-hidden": "true",
                                  },
                                }),
                                _vm._v(
                                  "\n            Exporting...\n          "
                                ),
                              ])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.selectedFormat === "jpg_from_psd" &&
                                      _vm.downloadInBackground
                                      ? "Queue export"
                                      : "Export"
                                  )
                                ),
                              ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "m-1",
                          attrs: { variant: "secondary" },
                          on: { click: _vm.onClose },
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "b-card",
            { attrs: { "no-body": "" } },
            [
              _c(
                "b-tabs",
                { attrs: { pills: "", card: "" } },
                [
                  _c(
                    "b-tab",
                    {
                      staticClass: "export-download-tab",
                      attrs: { title: "Download", active: "" },
                    },
                    [
                      !["idml"].includes(_vm.selectedFormat)
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "form-row export-field-row export-order-saved-settings",
                            },
                            [
                              _c("div", { staticClass: "col-md-2" }, [
                                _c("label", [_vm._v("Saved settings")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-10 form-group" },
                                [
                                  _c("ExportSelect", {
                                    attrs: {
                                      options: _vm.downloadSettingsOptions,
                                      placeholder: "Select settings",
                                      disabled: _vm.useTemplateSettings,
                                      "emit-option": "",
                                    },
                                    on: { select: _vm.applySavedSettings },
                                    model: {
                                      value: _vm.selectedDownloadSettings,
                                      callback: function ($$v) {
                                        _vm.selectedDownloadSettings = $$v
                                      },
                                      expression: "selectedDownloadSettings",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.useTemplateSettings || _vm.templateSettingsConsistent
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "form-row export-field-row export-order-format",
                            },
                            [
                              _c("div", { staticClass: "col-md-2" }, [
                                _c("label", [_vm._v("Format")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-10 form-group" },
                                [
                                  _c("ExportSelect", {
                                    staticClass: "form-control",
                                    attrs: {
                                      options: _vm.formats,
                                      disabled: _vm.useTemplateSettings,
                                    },
                                    on: { change: _vm.onExportTypeUpdated },
                                    model: {
                                      value: _vm.selectedFormat,
                                      callback: function ($$v) {
                                        _vm.selectedFormat = $$v
                                      },
                                      expression: "selectedFormat",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.warningMessage
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center alert-warning mt-2 font-xs px-2 py-1",
                                          staticStyle: {
                                            gap: "8px",
                                            width: "fit-content",
                                            height: "fit-content",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "bi bi-exclamation-triangle",
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.warningMessage) +
                                                "\n                "
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.selectedFormat === "pdf",
                              expression: "selectedFormat === 'pdf'",
                            },
                          ],
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-row export-field-row export-format-option",
                            },
                            [
                              _c("div", { staticClass: "col-md-2" }, [
                                _c("label", [_vm._v("Size")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-10 form-group" },
                                [
                                  _c("ExportSelect", {
                                    staticClass: "form-control",
                                    attrs: { options: _vm.pdfPageSizes },
                                    model: {
                                      value: _vm.selectedPdfPageSize,
                                      callback: function ($$v) {
                                        _vm.selectedPdfPageSize = $$v
                                      },
                                      expression: "selectedPdfPageSize",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.selectedFormat === "pptx",
                              expression: "selectedFormat === 'pptx'",
                            },
                          ],
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-row export-field-row export-format-option",
                            },
                            [
                              _c("div", { staticClass: "col-md-2" }, [
                                _c("label", [_vm._v("Size")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-10 form-group" },
                                [
                                  _c("ExportSelect", {
                                    staticClass: "form-control",
                                    attrs: { options: _vm.pptxPageSizes },
                                    model: {
                                      value: _vm.selectedPptxPageSize,
                                      callback: function ($$v) {
                                        _vm.selectedPptxPageSize = $$v
                                      },
                                      expression: "selectedPptxPageSize",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.selectedFormat === "pptx",
                              expression: "selectedFormat === 'pptx'",
                            },
                          ],
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-row export-field-row export-format-option",
                            },
                            [
                              _c("div", { staticClass: "col-md-2" }, [
                                _c("label", [_vm._v("PPTX output type")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-10 form-group" },
                                [
                                  _c("ExportSelect", {
                                    staticClass: "form-control",
                                    attrs: { options: _vm.pptxOutputTypes },
                                    on: { change: _vm.setSavedSettingsToNull },
                                    model: {
                                      value: _vm.pptxIncludeFonts,
                                      callback: function ($$v) {
                                        _vm.pptxIncludeFonts = $$v
                                      },
                                      expression: "pptxIncludeFonts",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.selectedFormat === "gif" ||
                                _vm.selectedFormat === "pdf",
                              expression:
                                "selectedFormat === 'gif' || selectedFormat === 'pdf'",
                            },
                          ],
                          staticClass: "export-order-download",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-row export-field-row container-downloadable-groups",
                            },
                            [
                              _c("div", { staticClass: "col-md-2" }, [
                                _c("label", [_vm._v("Group")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-10 form-group" },
                                [
                                  _c("MultipleSelectJquery", {
                                    staticClass: "export-pdf-groups-dropdown",
                                    attrs: {
                                      multiple: "",
                                      data: _vm.groupsInstances,
                                      options:
                                        _vm.downloadMultipleSelectOptions,
                                      placeholder: "Select groups...",
                                    },
                                    model: {
                                      value: _vm.selectedGroupInstances,
                                      callback: function ($$v) {
                                        _vm.selectedGroupInstances = $$v
                                      },
                                      expression: "selectedGroupInstances",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.selectedFormat === "pdf" &&
                          _vm.selectedGroupInstances.length == 1
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "form-row export-field-row export-format-option",
                                },
                                [
                                  _c("div", { staticClass: "col-md-2" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-10 form-group export-checkbox-setting",
                                    },
                                    [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.getDirectLinktoFile,
                                              expression: "getDirectLinktoFile",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.getDirectLinktoFile
                                            )
                                              ? _vm._i(
                                                  _vm.getDirectLinktoFile,
                                                  null
                                                ) > -1
                                              : _vm.getDirectLinktoFile,
                                          },
                                          on: {
                                            change: [
                                              function ($event) {
                                                var $$a =
                                                    _vm.getDirectLinktoFile,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.getDirectLinktoFile =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.getDirectLinktoFile =
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                  }
                                                } else {
                                                  _vm.getDirectLinktoFile = $$c
                                                }
                                              },
                                              _vm.setSavedSettingsToNull,
                                            ],
                                          },
                                        }),
                                        _vm._v(
                                          "\n                  Get direct link to the file\n                "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedFormat !== "pdf"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "form-row export-field-row container-downloadable-single-template",
                                },
                                [
                                  _c("div", { staticClass: "col-md-2" }, [
                                    _c("label", [_vm._v("Single Templates")]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-10 form-group" },
                                    [
                                      _c("MultipleSelectJquery", {
                                        attrs: {
                                          multiple: "",
                                          data: _vm.singleInstances,
                                          options:
                                            _vm.downloadMultipleSelectOptions,
                                          placeholder: "Select templates...",
                                        },
                                        on: {
                                          change: _vm.setSavedSettingsToNull,
                                        },
                                        model: {
                                          value: _vm.selectedSingleInstances,
                                          callback: function ($$v) {
                                            _vm.selectedSingleInstances = $$v
                                          },
                                          expression: "selectedSingleInstances",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !["gif", "pdf"].includes(
                                _vm.selectedFormat
                              ),
                              expression:
                                "!['gif', 'pdf'].includes(selectedFormat)",
                            },
                          ],
                          staticClass: "export-order-download",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-row export-field-row container-downloadable-templates",
                            },
                            [
                              _c("div", { staticClass: "col-md-2" }, [
                                _c("label", [_vm._v("Download")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-10 form-group" },
                                [
                                  _c("Multiselect", {
                                    attrs: {
                                      options: _vm.selectableInstances,
                                      "track-by": "instance_id",
                                      label: "name",
                                      loading: _vm.isTemplatesLoading,
                                      disabled: _vm.isTemplatesLoading,
                                      placeholder: "Select instances...",
                                      "close-on-select": false,
                                      "show-labels": false,
                                      multiple: "",
                                    },
                                    on: {
                                      select: _vm.setSavedSettingsToNull,
                                      remove: _vm.setSavedSettingsToNull,
                                      open: function ($event) {
                                        _vm.isDownloadDropdownOpen = true
                                      },
                                      close: function ($event) {
                                        _vm.isDownloadDropdownOpen = false
                                      },
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function ({ isOpen }) {
                                          return [
                                            _vm.selectedTemplateCount && !isOpen
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "export-selection-summary",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.selectedTemplateCount
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.selectedTemplateCount ===
                                                            1
                                                            ? "template"
                                                            : "templates"
                                                        ) +
                                                        " selected\n                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                      {
                                        key: "beforeList",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "export-template-actions",
                                              },
                                              [
                                                !_vm.allInstancesSelected
                                                  ? _c(
                                                      "button",
                                                      {
                                                        attrs: {
                                                          type: "button",
                                                        },
                                                        on: {
                                                          mousedown: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                          },
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.selectAllInstances.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        Select all\n                      "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "export-template-actions__unselect",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      mousedown: function (
                                                        $event
                                                      ) {
                                                        $event.preventDefault()
                                                      },
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.unselectAllInstances.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        Unselect all\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "option",
                                        fn: function ({ option }) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "export-template-option",
                                              },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "export-template-option__checkbox",
                                                  class: {
                                                    "export-template-option__checkbox--checked":
                                                      _vm.isInstanceSelected(
                                                        option
                                                      ),
                                                  },
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      title: option.name,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(option.name))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.selectedInstances,
                                      callback: function ($$v) {
                                        _vm.selectedInstances = $$v
                                      },
                                      expression: "selectedInstances",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      ["pptx"].includes(_vm.selectedFormat)
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "form-row export-field-row export-format-option",
                            },
                            [
                              _c("div", { staticClass: "col-md-2" }, [
                                _c("label", [_vm._v("Naming")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-10 form-group" },
                                [
                                  _c("ExportSelect", {
                                    staticClass: "form-control",
                                    attrs: { options: _vm.NAMINGS },
                                    model: {
                                      value: _vm.selectedNaming,
                                      callback: function ($$v) {
                                        _vm.selectedNaming = $$v
                                      },
                                      expression: "selectedNaming",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: ["pptx"].includes(_vm.selectedFormat),
                              expression: "['pptx'].includes(selectedFormat)",
                            },
                          ],
                          staticClass:
                            "form-row export-field-row export-format-option",
                        },
                        [
                          _c("div", { staticClass: "col-md-2" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-10 export-checkbox-setting",
                            },
                            [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.downloadAsOneFile,
                                      expression: "downloadAsOneFile",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.downloadAsOneFile
                                    )
                                      ? _vm._i(_vm.downloadAsOneFile, null) > -1
                                      : _vm.downloadAsOneFile,
                                  },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$a = _vm.downloadAsOneFile,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.downloadAsOneFile =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.downloadAsOneFile = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.downloadAsOneFile = $$c
                                        }
                                      },
                                      _vm.setSavedSettingsToNull,
                                    ],
                                  },
                                }),
                                _vm._v(
                                  "\n                Download as one file\n              "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: [
                                "psd",
                                "jpg_from_psd",
                                "psd_and_jpg",
                                "pptx",
                                /*'pdf', */ "png_from_psd",
                              ].includes(_vm.selectedFormat),
                              expression:
                                "['psd', 'jpg_from_psd', 'psd_and_jpg', 'pptx', /*'pdf', */'png_from_psd'].includes(selectedFormat)",
                            },
                          ],
                          staticClass:
                            "form-row export-field-row export-format-option export-format-option--checks",
                        },
                        [
                          _c("div", { staticClass: "col-md-2" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-10 form-group export-inline-checks",
                            },
                            [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.downloadInBackground,
                                      expression: "downloadInBackground",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.downloadInBackground
                                    )
                                      ? _vm._i(_vm.downloadInBackground, null) >
                                        -1
                                      : _vm.downloadInBackground,
                                  },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$a = _vm.downloadInBackground,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.downloadInBackground =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.downloadInBackground = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.downloadInBackground = $$c
                                        }
                                      },
                                      _vm.setSavedSettingsToNull,
                                    ],
                                  },
                                }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.selectedFormat === "jpg_from_psd"
                                        ? "Email me when export is ready"
                                        : "Download in background"
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.selectedFormat === "jpg_from_psd",
                                      expression:
                                        "selectedFormat === 'jpg_from_psd'",
                                    },
                                  ],
                                  attrs: {
                                    title:
                                      "Compares exported images with on-screen images",
                                  },
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.exportValidation,
                                        expression: "exportValidation",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.exportValidation
                                      )
                                        ? _vm._i(_vm.exportValidation, null) >
                                          -1
                                        : _vm.exportValidation,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.exportValidation =
                                          !_vm.exportValidation
                                      },
                                      change: function ($event) {
                                        var $$a = _vm.exportValidation,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.exportValidation =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.exportValidation = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.exportValidation = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                Export validation\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.selectedFormat === "jpg_from_psd" &&
                                _vm.downloadInBackground,
                              expression:
                                "selectedFormat === 'jpg_from_psd' && downloadInBackground",
                            },
                          ],
                          staticClass:
                            "form-row export-field-row export-format-option",
                        },
                        [
                          _c("div", { staticClass: "col-md-2" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-10 form-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.notifyEmail,
                                  expression: "notifyEmail",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "email",
                                placeholder: "Email address",
                              },
                              domProps: { value: _vm.notifyEmail },
                              on: {
                                change: _vm.setSavedSettingsToNull,
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.notifyEmail = $event.target.value
                                },
                              },
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      ["pdf"].includes(_vm.selectedFormat)
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "form-row export-field-row export-format-option",
                            },
                            [
                              _c("div", { staticClass: "col-md-2" }, [
                                _c("label", [_vm._v("Settings")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-10" },
                                [
                                  _c("Multiselect", {
                                    staticClass: "export-settings-dropdown",
                                    attrs: {
                                      options: _vm.pdfOptions,
                                      placeholder: "Select options",
                                      "track-by": "value",
                                      label: "text",
                                      multiple: true,
                                    },
                                    on: { input: _vm.applyPdfOptions },
                                    model: {
                                      value: _vm.selectedPdfOptions,
                                      callback: function ($$v) {
                                        _vm.selectedPdfOptions = $$v
                                      },
                                      expression: "selectedPdfOptions",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      (!_vm.useTemplateSettings ||
                        _vm.templateSettingsConsistent) &&
                      [
                        "jpg",
                        "png",
                        "pdf",
                        "jpg_from_psd",
                        "png_from_psd",
                      ].includes(_vm.selectedFormat)
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "export-field-row export-output-row export-order-output",
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "export-field-label" },
                                [_vm._v("Output")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "export-output-grid",
                                  class: {
                                    "export-output-grid--single": ![
                                      "jpg",
                                      "png",
                                    ].includes(_vm.selectedFormat),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "export-output-field" },
                                    [
                                      _c("label", [_vm._v("DPI")]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "export-dpi-controls" },
                                        [
                                          _c("ExportSelect", {
                                            attrs: {
                                              options: _vm.dpiPresets,
                                              disabled: _vm.useTemplateSettings,
                                            },
                                            on: { change: _vm.updateDpi },
                                            model: {
                                              value: _vm.selectedDpi,
                                              callback: function ($$v) {
                                                _vm.selectedDpi = _vm._n($$v)
                                              },
                                              expression: "selectedDpi",
                                            },
                                          }),
                                          _vm._v(" "),
                                          !_vm.selectedDpi
                                            ? _c("b-form-input", {
                                                attrs: {
                                                  type: "number",
                                                  autofocus: "",
                                                  disabled:
                                                    _vm.useTemplateSettings,
                                                },
                                                on: {
                                                  change:
                                                    _vm.setSavedSettingsToNull,
                                                },
                                                model: {
                                                  value: _vm.dpi,
                                                  callback: function ($$v) {
                                                    _vm.dpi = _vm._n($$v)
                                                  },
                                                  expression: "dpi",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  ["jpg", "png"].includes(_vm.selectedFormat)
                                    ? _c(
                                        "div",
                                        { staticClass: "export-output-field" },
                                        [
                                          _c("label", [_vm._v("Size")]),
                                          _vm._v(" "),
                                          _c("ExportSelect", {
                                            staticClass: "form-control",
                                            attrs: {
                                              options: _vm.sizeSelectOptions,
                                              disabled: _vm.useTemplateSettings,
                                            },
                                            on: {
                                              change:
                                                _vm.setSavedSettingsToNull,
                                            },
                                            model: {
                                              value: _vm.selectedSize,
                                              callback: function ($$v) {
                                                _vm.selectedSize = $$v
                                              },
                                              expression: "selectedSize",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _vm.selectedSize ===
                                          _vm.SIZE_OPTIONS_TYPE
                                            .SCALE_DOWN_BY_PERCENTAGE
                                            ? _c(
                                                "div",
                                                [
                                                  _c("div", {
                                                    staticClass: "my-2",
                                                  }),
                                                  _vm._v(" "),
                                                  _c("b-form-input", {
                                                    attrs: { type: "number" },
                                                    on: {
                                                      change:
                                                        _vm.setSavedSettingsToNull,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.size.percentage,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.size,
                                                          "percentage",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "size.percentage",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.selectedSize ===
                                          _vm.SIZE_OPTIONS_TYPE
                                            .SCALE_DOWN_BY_DIMENSIONS
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dimensions-container",
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass: "my-2",
                                                  }),
                                                  _vm._v(" "),
                                                  _c("b-form-input", {
                                                    attrs: { type: "number" },
                                                    on: {
                                                      change:
                                                        _vm.handleWidthChange,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.size.dimensions
                                                          .width,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.size.dimensions,
                                                          "width",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "size.dimensions.width",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n                  x\n                  "
                                                  ),
                                                  _c("b-form-input", {
                                                    attrs: { type: "number" },
                                                    on: {
                                                      change:
                                                        _vm.handleHeightChange,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.size.dimensions
                                                          .height,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.size.dimensions,
                                                          "height",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "size.dimensions.height",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.selectedFormat === "pdf" &&
                                _vm.useMpdf == true,
                              expression:
                                "selectedFormat === 'pdf' && useMpdf == true",
                            },
                          ],
                          staticClass:
                            "form-row export-field-row export-format-option",
                        },
                        [
                          _c("div", { staticClass: "col-md-2" }, [
                            _c("label", [_vm._v("Color profile")]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-10 form-group" },
                            [
                              _c("ExportSelect", {
                                attrs: { options: _vm.colorProfilePresets },
                                on: { change: _vm.updateColorProfile },
                                model: {
                                  value: _vm.selectedColorProfile,
                                  callback: function ($$v) {
                                    _vm.selectedColorProfile = $$v
                                  },
                                  expression: "selectedColorProfile",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.selectedFormat === "pdf",
                              expression: "selectedFormat === 'pdf'",
                            },
                          ],
                          staticClass:
                            "form-row export-field-row export-format-option export-bleed-option",
                        },
                        [
                          _c("div", { staticClass: "col-md-2 mt-2" }, [
                            _c("label", [_vm._v("Bleed")]),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                staticClass: "bleed-link-toggle",
                                attrs: {
                                  title: _vm.bleedLinked
                                    ? "Unlink sides"
                                    : "Link all sides",
                                },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.bleedLinked,
                                      expression: "bleedLinked",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.bleedLinked)
                                      ? _vm._i(_vm.bleedLinked, null) > -1
                                      : _vm.bleedLinked,
                                  },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$a = _vm.bleedLinked,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.bleedLinked = $$a.concat([
                                                $$v,
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.bleedLinked = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.bleedLinked = $$c
                                        }
                                      },
                                      _vm.onBleedLinkToggle,
                                    ],
                                  },
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "fas",
                                  class: _vm.bleedLinked
                                    ? "fa-link"
                                    : "fa-unlink",
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Link sides")]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-10 mt-2" }, [
                            _c(
                              "div",
                              { staticClass: "form-row export-bleed-grid" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-md-2 form-group" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "bleed-label" },
                                      [_vm._v("Top")]
                                    ),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      attrs: {
                                        type: "number",
                                        min: "0",
                                        step: "any",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.handleBleedInput("top")
                                        },
                                      },
                                      model: {
                                        value: _vm.bleed.top,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.bleed,
                                            "top",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "bleed.top",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-2 form-group" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "bleed-label" },
                                      [_vm._v("Bottom")]
                                    ),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      attrs: {
                                        type: "number",
                                        min: "0",
                                        step: "any",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.handleBleedInput("bottom")
                                        },
                                      },
                                      model: {
                                        value: _vm.bleed.bottom,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.bleed,
                                            "bottom",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "bleed.bottom",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-2 form-group" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "bleed-label" },
                                      [_vm._v("Left")]
                                    ),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      attrs: {
                                        type: "number",
                                        min: "0",
                                        step: "any",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.handleBleedInput("left")
                                        },
                                      },
                                      model: {
                                        value: _vm.bleed.left,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.bleed,
                                            "left",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "bleed.left",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-2 form-group" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "bleed-label" },
                                      [_vm._v("Right")]
                                    ),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      attrs: {
                                        type: "number",
                                        min: "0",
                                        step: "any",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.handleBleedInput("right")
                                        },
                                      },
                                      model: {
                                        value: _vm.bleed.right,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.bleed,
                                            "right",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "bleed.right",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-4 form-group" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "bleed-label" },
                                      [_vm._v("Unit")]
                                    ),
                                    _vm._v(" "),
                                    _c("ExportSelect", {
                                      attrs: { options: _vm.bleedUnits },
                                      on: {
                                        change: _vm.setSavedSettingsToNull,
                                      },
                                      model: {
                                        value: _vm.bleed.unit,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.bleed, "unit", $$v)
                                        },
                                        expression: "bleed.unit",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.selectedFormat === "pdf",
                              expression: "selectedFormat === 'pdf'",
                            },
                          ],
                          staticClass:
                            "form-row export-field-row export-format-option",
                        },
                        [
                          _c("div", { staticClass: "col-md-2" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-10 form-group export-checkbox-setting",
                            },
                            [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.trimMarks,
                                      expression: "trimMarks",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.trimMarks)
                                      ? _vm._i(_vm.trimMarks, null) > -1
                                      : _vm.trimMarks,
                                  },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$a = _vm.trimMarks,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.trimMarks = $$a.concat([
                                                $$v,
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.trimMarks = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.trimMarks = $$c
                                        }
                                      },
                                      _vm.setSavedSettingsToNull,
                                    ],
                                  },
                                }),
                                _vm._v(
                                  "\n                Trim marks\n              "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isXlsxPriceFormatSelected
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "form-row export-field-row export-format-option container-platforms",
                            },
                            [
                              _c("div", { staticClass: "col-md-2" }, [
                                _c("label", [_vm._v("Export Type")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-10 form-group" },
                                [
                                  _c("ExportSelect", {
                                    staticClass: "form-control",
                                    attrs: {
                                      options: _vm.xlsxPrice.exportTypeOptions,
                                    },
                                    model: {
                                      value: _vm.xlsxPrice.selectedExportType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.xlsxPrice,
                                          "selectedExportType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "xlsxPrice.selectedExportType",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isXlsxPriceFormatSelected &&
                      [
                        "CreateNewTabForEachTemplate",
                        "CreateXlsxForEachTemplate",
                      ].includes(_vm.xlsxPrice.selectedExportType)
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "form-row export-field-row export-format-option container-platforms",
                            },
                            [
                              _c("div", { staticClass: "col-md-2" }, [
                                _c("label", [_vm._v("Tab Names Source")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-10 form-group" },
                                [
                                  _c("ExportSelect", {
                                    staticClass: "form-control",
                                    attrs: {
                                      options:
                                        _vm.xlsxPrice.tabNameSourceOptions,
                                    },
                                    model: {
                                      value:
                                        _vm.xlsxPrice.selectedTabNameSource,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.xlsxPrice,
                                          "selectedTabNameSource",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "xlsxPrice.selectedTabNameSource",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedFormat === "html"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "form-row export-field-row export-format-option container-platforms",
                            },
                            [
                              _c("div", { staticClass: "col-md-2" }, [
                                _c("label", [_vm._v("Platform")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-10 form-group" },
                                [
                                  _c("ExportSelect", {
                                    staticClass: "form-control",
                                    attrs: { options: _vm.platformOptions },
                                    on: { change: _vm.setSavedSettingsToNull },
                                    model: {
                                      value: _vm.selectedPlatform,
                                      callback: function ($$v) {
                                        _vm.selectedPlatform = $$v
                                      },
                                      expression: "selectedPlatform",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkTestMode()
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-row export-field-row export-format-option export-test-mode-option",
                              },
                              [
                                _c("div", { staticClass: "col-md-2" }, [
                                  _c("label", [
                                    _vm._v("Test mode\n                  "),
                                    _c("i", {
                                      staticClass:
                                        "cursor-pointer glyphicon glyphicon-refresh reset-text-position",
                                      attrs: { title: "Get data to json" },
                                      on: { click: _vm.setJsonText },
                                    }),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-10 form-group" },
                                  [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.jsonText,
                                          expression: "jsonText",
                                        },
                                      ],
                                      staticClass: "json-editor",
                                      attrs: { rows: "15", cols: "80" },
                                      domProps: { value: _vm.jsonText },
                                      on: {
                                        input: [
                                          function ($event) {
                                            if ($event.target.composing) return
                                            _vm.jsonText = $event.target.value
                                          },
                                          _vm.validateJSON,
                                        ],
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.errorMessage
                                      ? _c(
                                          "p",
                                          { staticClass: "error-message" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.errorMessage) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      (!_vm.useTemplateSettings ||
                        _vm.templateSettingsConsistent) &&
                      _vm.compressionCanBeApplied
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "form-row export-field-row export-order-compression",
                            },
                            [
                              _c("div"),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "export-checkbox-setting" },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "compressToMaxFileSize" } },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.compressToMaxFileSize,
                                            expression: "compressToMaxFileSize",
                                          },
                                        ],
                                        attrs: {
                                          id: "compressToMaxFileSize",
                                          type: "checkbox",
                                          disabled: _vm.useTemplateSettings,
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.compressToMaxFileSize
                                          )
                                            ? _vm._i(
                                                _vm.compressToMaxFileSize,
                                                null
                                              ) > -1
                                            : _vm.compressToMaxFileSize,
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$a =
                                                  _vm.compressToMaxFileSize,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.compressToMaxFileSize =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.compressToMaxFileSize =
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                }
                                              } else {
                                                _vm.compressToMaxFileSize = $$c
                                              }
                                            },
                                            function ($event) {
                                              return _vm.handleCheckboxChange(
                                                "compressToMaxFileSize"
                                              )
                                            },
                                          ],
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Max file size")]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.compressToMaxFileSize
                                    ? _c(
                                        "div",
                                        { staticClass: "export-max-file-size" },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              type: "number",
                                              placeholder: "Max file size",
                                              disabled: _vm.useTemplateSettings,
                                            },
                                            on: {
                                              change:
                                                _vm.setSavedSettingsToNull,
                                            },
                                            model: {
                                              value:
                                                _vm.compressToMaxFileSizeValue,
                                              callback: function ($$v) {
                                                _vm.compressToMaxFileSizeValue =
                                                  $$v
                                              },
                                              expression:
                                                "compressToMaxFileSizeValue",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("KB")]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !["feed", "idml", "xlsx_price"].includes(
                        _vm.selectedFormat
                      )
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "form-row export-field-row export-order-folder -groups",
                            },
                            [
                              _c("div", { staticClass: "col-md-2" }, [
                                _c("label", [_vm._v("Save to folder")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-10 form-group" },
                                [
                                  _c("FolderTreeSelect", {
                                    ref: "selectedFolderInput",
                                    attrs: {
                                      items: _vm.folders,
                                      "new-folder-name": _vm.isNewFolder
                                        ? _vm.newFolderName
                                        : "",
                                      placeholder:
                                        "Browse File Browser folders...",
                                    },
                                    on: {
                                      input: _vm.handleFolderSelection,
                                      "create-folder":
                                        _vm.handleNewFolderSelection,
                                      "clear-new-folder":
                                        _vm.clearNewFolderSelection,
                                    },
                                    model: {
                                      value: _vm.selectedFolder,
                                      callback: function ($$v) {
                                        _vm.selectedFolder = $$v
                                      },
                                      expression: "selectedFolder",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.selectedFolder &&
                                            _vm.selectedFormat,
                                          expression:
                                            "selectedFolder && selectedFormat",
                                        },
                                      ],
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary my-2 font-xs",
                                            on: {
                                              click: _vm.openFolderInNewTab,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Open folder\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary font-xs",
                                            on: { click: _vm.copyToClipboard },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Copy link\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary font-xs",
                                            attrs: {
                                              disabled:
                                                _vm.isGeneratingShareLink,
                                            },
                                            on: {
                                              click: _vm.copySharedToClipboard,
                                            },
                                          },
                                          [
                                            _vm.isGeneratingShareLink
                                              ? _c("span", {
                                                  staticClass:
                                                    "spinner-border spinner-border-sm",
                                                  attrs: {
                                                    role: "status",
                                                    "aria-hidden": "true",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                    Copy share link\n                  "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasAdvancedOptions
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "export-advanced export-order-advanced",
                            },
                            [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName:
                                        "v-b-toggle.export-advanced-options",
                                      modifiers: {
                                        "export-advanced-options": true,
                                      },
                                    },
                                  ],
                                  staticClass: "export-advanced-toggle",
                                  attrs: { type: "button" },
                                },
                                [
                                  _c("span", [_vm._v("Advanced")]),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "bi bi-chevron-down",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-collapse",
                                { attrs: { id: "export-advanced-options" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "export-advanced-content" },
                                    [
                                      _vm.templateSettingsCanBeApplied
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-row export-field-row",
                                            },
                                            [
                                              _c("div"),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "export-checkbox-setting",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "useTemplateSettings",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.useTemplateSettings,
                                                            expression:
                                                              "useTemplateSettings",
                                                          },
                                                        ],
                                                        attrs: {
                                                          id: "useTemplateSettings",
                                                          type: "checkbox",
                                                        },
                                                        domProps: {
                                                          checked:
                                                            Array.isArray(
                                                              _vm.useTemplateSettings
                                                            )
                                                              ? _vm._i(
                                                                  _vm.useTemplateSettings,
                                                                  null
                                                                ) > -1
                                                              : _vm.useTemplateSettings,
                                                        },
                                                        on: {
                                                          change: [
                                                            function ($event) {
                                                              var $$a =
                                                                  _vm.useTemplateSettings,
                                                                $$el =
                                                                  $event.target,
                                                                $$c =
                                                                  $$el.checked
                                                                    ? true
                                                                    : false
                                                              if (
                                                                Array.isArray(
                                                                  $$a
                                                                )
                                                              ) {
                                                                var $$v = null,
                                                                  $$i = _vm._i(
                                                                    $$a,
                                                                    $$v
                                                                  )
                                                                if (
                                                                  $$el.checked
                                                                ) {
                                                                  $$i < 0 &&
                                                                    (_vm.useTemplateSettings =
                                                                      $$a.concat(
                                                                        [$$v]
                                                                      ))
                                                                } else {
                                                                  $$i > -1 &&
                                                                    (_vm.useTemplateSettings =
                                                                      $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        ))
                                                                }
                                                              } else {
                                                                _vm.useTemplateSettings =
                                                                  $$c
                                                              }
                                                            },
                                                            function ($event) {
                                                              return _vm.handleCheckboxChange(
                                                                "useTemplateSettings"
                                                              )
                                                            },
                                                          ],
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "template-settings-label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Use template settings"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.bulkNamingCanBeApplied
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-row export-field-row export-advanced-bulk-naming",
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "label",
                                                  {
                                                    attrs: {
                                                      for: "bulkNaming",
                                                    },
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.isBulkNaming,
                                                          expression:
                                                            "isBulkNaming",
                                                        },
                                                      ],
                                                      attrs: {
                                                        id: "bulkNaming",
                                                        type: "checkbox",
                                                      },
                                                      domProps: {
                                                        checked: Array.isArray(
                                                          _vm.isBulkNaming
                                                        )
                                                          ? _vm._i(
                                                              _vm.isBulkNaming,
                                                              null
                                                            ) > -1
                                                          : _vm.isBulkNaming,
                                                      },
                                                      on: {
                                                        change: [
                                                          function ($event) {
                                                            var $$a =
                                                                _vm.isBulkNaming,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v = null,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  (_vm.isBulkNaming =
                                                                    $$a.concat([
                                                                      $$v,
                                                                    ]))
                                                              } else {
                                                                $$i > -1 &&
                                                                  (_vm.isBulkNaming =
                                                                    $$a
                                                                      .slice(
                                                                        0,
                                                                        $$i
                                                                      )
                                                                      .concat(
                                                                        $$a.slice(
                                                                          $$i +
                                                                            1
                                                                        )
                                                                      ))
                                                              }
                                                            } else {
                                                              _vm.isBulkNaming =
                                                                $$c
                                                            }
                                                          },
                                                          _vm.setBulkNaming,
                                                        ],
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v("Bulk naming"),
                                                    ]),
                                                  ]
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("div", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.bulkName,
                                                      expression: "bulkName",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    placeholder:
                                                      "Enter base name (e.g. Product_Hero)",
                                                    disabled: !_vm.isBulkNaming,
                                                  },
                                                  domProps: {
                                                    value: _vm.bulkName,
                                                  },
                                                  on: {
                                                    input: [
                                                      function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.bulkName =
                                                          $event.target.value
                                                      },
                                                      _vm.applyBulkName,
                                                    ],
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _vm.isBulkNaming
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "export-bulk-names-editor",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "export-bulk-names-editor__header",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Filenames (one per line)"
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "button",
                                                              {
                                                                attrs: {
                                                                  type: "button",
                                                                },
                                                                on: {
                                                                  click:
                                                                    _vm.resetBulkNames,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          Reset all\n                        "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("textarea", {
                                                          staticClass:
                                                            "form-control",
                                                          attrs: { rows: "5" },
                                                          domProps: {
                                                            value:
                                                              _vm.bulkNamesText,
                                                          },
                                                          on: {
                                                            input:
                                                              _vm.onBulkNamesInput,
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "export-bulk-names-editor__footer",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.selectedTemplateCount
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  _vm.selectedTemplateCount ===
                                                                    1
                                                                    ? "line"
                                                                    : "lines"
                                                                ) +
                                                                " expected\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.length
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "form-row export-field-row export-order-errors",
                            },
                            [
                              _c("div", { staticClass: "col-md-2" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-10" },
                                _vm._l(_vm.errors, function (error, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "alert alert-warning",
                                      attrs: { role: "alert" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(error) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    { attrs: { title: "Saved settings" } },
                    [
                      _c("SavedDownloadSettingsTab", {
                        ref: "savedDownloadSettingsTab",
                        attrs: { "is-master-admin": _vm.isMasterAdmin },
                        on: { "settings-updated": _vm.onSettingsUpdated },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.compressionCanBeApplied
                    ? _c(
                        "b-tab",
                        { attrs: { title: "File Sizes" } },
                        [
                          _c("ExportFileSizesTab", {
                            attrs: {
                              instances: _vm.instances,
                              "selected-instances": _vm.selectedInstances,
                              disabled: _vm.fileSizesTabDisabled,
                            },
                            on: { input: _vm.setSavedSettingsToNull },
                            model: {
                              value: _vm.perTemplateMaxFileSizes,
                              callback: function ($$v) {
                                _vm.perTemplateMaxFileSizes = $$v
                              },
                              expression: "perTemplateMaxFileSizes",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  ["pptx", "pdf"].includes(_vm.selectedFormat)
                    ? _c(
                        "b-tab",
                        { attrs: { title: "Page numbers" } },
                        [
                          _c("ExportPageNumerationTab", {
                            attrs: { "page-numeration": _vm.pageNumeration },
                            on: {
                              "data-updated": function ($event) {
                                return _vm.onPageNumerationUpdate($event)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  ["pptx", "pdf"].includes(_vm.selectedFormat)
                    ? _c(
                        "b-tab",
                        { attrs: { title: "Page header" } },
                        [
                          _c("ExportPageEdgeTab", {
                            attrs: {
                              "label-text": "Header Height",
                              "section-data": _vm.pageHeader,
                            },
                            on: {
                              "data-updated": function ($event) {
                                _vm.pageHeader = $event
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  ["pptx", "pdf"].includes(_vm.selectedFormat)
                    ? _c(
                        "b-tab",
                        { attrs: { title: "Page footer" } },
                        [
                          _c("ExportPageEdgeTab", {
                            attrs: {
                              "label-text": "Footer Height",
                              "section-data": _vm.pageFooter,
                            },
                            on: {
                              "data-updated": function ($event) {
                                _vm.pageFooter = $event
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  ["pdf"].includes(_vm.selectedFormat)
                    ? _c(
                        "b-tab",
                        { attrs: { title: "Add pages" } },
                        [
                          _c("ExportAddPagesTab", {
                            attrs: {
                              "add-pages": _vm.addPages,
                              "group-instances": _vm.groupsInstances,
                            },
                            on: {
                              "data-updated": function ($event) {
                                _vm.addPages = $event
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  ["pdf"].includes(_vm.selectedFormat)
                    ? _c(
                        "b-tab",
                        { attrs: { title: "Links" } },
                        [
                          _c("ExportLinksTab", {
                            attrs: { links: _vm.links },
                            on: {
                              "data-updated": function ($event) {
                                _vm.links = $event
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("SaveDownloadSettingsModal", {
        ref: "saveDownloadSettingsModal",
        attrs: { "is-master-admin": _vm.isMasterAdmin },
        on: { saved: _vm.onSettingSaved },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }